module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37865864!./~/vue-loader/lib/selector.js?type=template&index=0!./src/docs/UkOffcanvas.doc.vue
// module id = 284
// module chunks = 2